import React from "react"
import { Card, Container, Row, Col, Badge,Button } from "react-bootstrap"
import { FaHeart, FaUsers, FaAward, FaClock, FaRocket, FaStar, FaWhatsapp,FaEnvelope,FaFacebook,FaInstagram,FaYoutube,FaPhone } from "react-icons/fa"
import Footer from "./Footer"

export default function AboutPage() {
  return (
    <div className="min-vh-100">
      {/* Hero Section */}
      <section
        className="position-relative overflow-hidden py-5"
        style={{
          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          minHeight: "60vh",
        }}
      >
        {/* Animated Background Elements */}
        {/* <div className="position-absolute w-100 h-100">
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "200px",
              height: "200px",
              background: "white",
              top: "20%",
              right: "10%",
              animation: "float 6s ease-in-out infinite",
            }}
          ></div>
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "150px",
              height: "150px",
              background: "white",
              bottom: "20%",
              left: "5%",
              animation: "float 8s ease-in-out infinite reverse",
            }}
          ></div>
        </div> */}

        <Container className="position-relative">
          <div className="text-center text-white py-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <FaHeart className="me-2" />
              <span className="fw-medium">Our Story</span>
            </div>

            <h1 className="display-3 fw-bold mb-4">About Aidify</h1>
            <p className="fs-5 opacity-90" style={{ maxWidth: "700px", margin: "0 auto", lineHeight: "1.6" }}>
              We're dedicated to connecting patients with Aidify professionals when they need it most. Our mission
              is to make quality Aidify accessible, immediate, and stress-free.
            </p>
          </div>
        </Container>
      </section>

      {/* Story Section */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6}>
              <div
                className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
                style={{
                  background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                  color: "white",
                }}
              >
                <FaRocket className="me-2" />
                <span className="fw-medium">Our Journey</span>
              </div>

              <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
                Revolutionizing Aidify Access
              </h2>
              <p className="text-muted mb-4" style={{ lineHeight: "1.7", fontSize: "1.1rem" }}>
                Founded in 2020, Aidify was born from a simple yet powerful idea: Aidify should be accessible
                when you need it most. Our founders experienced firsthand the frustration of trying to find urgent
                medical care during off-hours.
              </p>
              <p className="text-muted mb-4" style={{ lineHeight: "1.7", fontSize: "1.1rem" }}>
                Today, we've helped over 50,000 patients connect with qualified Aidify professionals, providing
                peace of mind and immediate access to medical expertise.
              </p>
              <p className="text-muted" style={{ lineHeight: "1.7", fontSize: "1.1rem" }}>
                We work with a network of licensed physicians, specialists, and Aidify facilities to ensure you
                receive the best possible care, exactly when you need it.
              </p>
            </Col>
            <Col lg={6}>
              <div className="position-relative">
              
                <img
                  src="/logo-aidify.png"
                  alt="Aidify logo"
                  className="img-fluid rounded-4 position-relative"
                  style={{
                    zIndex: 1,
                    // boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="py-5" style={{ backgroundColor: "white" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Our Impact in Numbers
            </h2>
            <p className="fs-5 text-muted">Trusted by thousands of patients worldwide</p>
          </div>

          <Row className="g-4">
            {[
              {
                icon: FaUsers,
                number: "50K+",
                label: "Patients Served",
                gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                delay: "0s",
              },
              {
                icon: FaHeart,
                number: "500+",
                label: "Partner Doctors",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                delay: "0.1s",
              },
              {
                icon: FaClock,
                number: "24/7",
                label: "Availability",
                gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                delay: "0.2s",
              },
              {
                icon: FaAward,
                number: "98%",
                label: "Satisfaction Rate",
                gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                delay: "0.3s",
              },
            ].map((stat, index) => (
              <Col md={6} lg={3} key={index}>
                <Card
                  className="text-center border-0 rounded-4 h-100"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    animationDelay: stat.delay,
                    animation: "fadeInUp 0.8s ease forwards",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <Card.Body className="p-5">
                    <div
                      className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "80px",
                        height: "80px",
                        background: stat.gradient,
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <stat.icon size={32} className="text-white" />
                    </div>
                    <h3 className="display-5 fw-bold mb-2" style={{ color: "#1f2937" }}>
                      {stat.number}
                    </h3>
                    <p className="text-muted mb-0">{stat.label}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Values Section */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          <div className="text-center mb-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                color: "white",
              }}
            >
              <FaStar className="me-2" />
              <span className="fw-medium">Our Values</span>
            </div>

            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              What Drives Us Forward
            </h2>
            <p className="fs-5 text-muted" style={{ maxWidth: "600px", margin: "0 auto" }}>
              Our core values guide everything we do in delivering exceptional Aidify services
            </p>
          </div>

          <Row className="g-4">
            {[
              {
                title: "Accessibility",
                description:
                  "Aidify should be available to everyone, regardless of time or location. We break down barriers to medical care.",
                gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
              },
              {
                title: "Quality",
                description:
                  "We partner only with licensed, experienced Aidify professionals who meet our strict quality standards.",
                gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
              },
              {
                title: "Compassion",
                description:
                  "Every interaction is handled with empathy and understanding, because we know health concerns can be stressful.",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              },
            ].map((value, index) => (
              <Col md={4} key={index}>
                <Card
                  className="h-100 border-0 rounded-4 overflow-hidden"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <div
                    className="p-1"
                    style={{
                      background: value.gradient,
                    }}
                  >
                    <Card.Body className="p-4 bg-white rounded-4">
                      <Card.Title className="h4 fw-bold mb-3" style={{ color: "#1f2937" }}>
                        {value.title}
                      </Card.Title>
                      <Card.Text className="text-muted" style={{ lineHeight: "1.6" }}>
                        {value.description}
                      </Card.Text>
                    </Card.Body>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      {/* <section className="py-5" style={{ backgroundColor: "white" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Meet Our Leadership Team
            </h2>
            <p className="fs-5 text-muted">Experienced professionals dedicated to your health</p>
          </div>

          <Row className="g-4">
            {[
              {
                name: "Dr. Sarah Mitchell",
                role: "Chief Medical Officer",
                image: "/placeholder.svg?height=400&width=400",
                bio: "Board-certified physician with 15+ years in emergency medicine",
                gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
              },
              {
                name: "James Rodriguez",
                role: "CEO & Founder",
                image: "/placeholder.svg?height=400&width=400",
                bio: "Aidify technology entrepreneur passionate about patient access",
                gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
              },
              {
                name: "Lisa Chen",
                role: "Head of Operations",
                image: "/placeholder.svg?height=400&width=400",
                bio: "Operations expert ensuring seamless patient-doctor connections",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              },
            ].map((member, index) => (
              <Col md={4} key={index}>
                <Card
                  className="text-center border-0 rounded-4 overflow-hidden"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <div className="position-relative">
                    <img
                      src={member.image || "/placeholder.svg"}
                      alt={member.name}
                      className="w-100"
                      style={{ height: "300px", objectFit: "cover" }}
                    />
                    <div
                      className="position-absolute bottom-0 start-0 w-100 p-4"
                      style={{
                        background: "linear-gradient(transparent, rgba(0, 0, 0, 0.7))",
                      }}
                    >
                      <Badge
                        className="px-3 py-2 rounded-pill fw-medium"
                        style={{
                          background: member.gradient,
                          border: "none",
                        }}
                      >
                        {member.role}
                      </Badge>
                    </div>
                  </div>
                  <Card.Body className="p-4">
                    <Card.Title className="h4 fw-bold mb-2" style={{ color: "#1f2937" }}>
                      {member.name}
                    </Card.Title>
                    <Card.Text className="text-muted">{member.bio}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}
       <Footer/>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  )
}
